module.exports = __webpack_public_path__ + "static/media/image-login.13ab4ed3.jpeg";